export interface Video {
  title: string;
  imagePath: string;
  url: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const tutorialsTitles = { '1': 'support/tutorialTitle1', '2': 'support/tutorialTitle2', '3': 'support/tutorialTitle3' }

export const iSophiVideos: Video[] = [
  {
    imagePath: '/assets/img/support/videa/isophi-playlist-video1.png',
    title: '1',
    url: 'https://www.youtube.com/watch?v=mWyoYa5W_78&list=PLDn4jfxt89ZQAqFQr1Wt7S9BCJxFYVcp5&index=2&ab_channel=iSophiEducation'
  },
  {
    imagePath: '/assets/img/support/videa/isophi-playlist-video2.png',
    title: '2',
    url: 'https://www.youtube.com/watch?v=oHTIuYPuOUc&list=PLDn4jfxt89ZQAqFQr1Wt7S9BCJxFYVcp5&index=3&ab_channel=iSophiEducation'
  },
  {
    imagePath: '/assets/img/support/videa/isophi-playlist-video3.png',
    title: '3',
    url: 'https://www.youtube.com/watch?v=D9k6AIyrYsQ&list=PLDn4jfxt89ZQAqFQr1Wt7S9BCJxFYVcp5&index=4&ab_channel=iSophiEducation'
  }
];
